module.exports = __webpack_public_path__ + "img/aeroland-digital-store-hero-image-reup.d9010f75.png";